import 'vuetify/styles'

import { createVuetify } from 'vuetify'
import { md3 } from 'vuetify/blueprints'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

export const vuetify = createVuetify({
  blueprint: md3,
  theme: {
    defaultTheme: 'starmind',
    themes: {
      starmind: {
        dark: false,
        colors: {
          primary: '#432CA0',
          background: '#fafafa',
          error: '#dd2c00',
          warning: '#fee485',
        },
      },
    },
  },
  defaults: {
    VBtn: {
      color: 'primary',
      elevation: 0,
    },
    VTextField: {
      color: 'primary',
      variant: 'outlined',
    },
    VCheckbox: {
      color: 'primary',
    },
    VSelect: {
      variant: 'outlined',
    },
    VInput: {
      class: 'mb-n1', // reduces the spacing between inputs
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})
